export default __webpack_public_path__ + "e246867ed453446bf15e0e2794545ef4.png";